import { ISDCardPacket } from '../interfaces/ISDCardPacket'
import { IChartPackets } from '../transformLogToChartPacket'
import { parseSDCardPacket } from './parseSDCardPacket'

export function transformSDCardLogToChartPackets(content: string): IChartPackets {
    const packets: IChartPackets = {
        dpr: [],
        tankPressures: [],
        ticks: [],
        modes: [],
        magnitudes: {
            dpr: 'bar',
            lox: 'bar',
            fuel: 'bar',
        },
    }

    // * PARSE
    // discard the first packet, since its the header
    const [, ...telemetryPackets] = content.split('\n')

    const parsedPackets = telemetryPackets
        .map((packet) => parseSDCardPacket(packet))
        .filter((f) => f) as ISDCardPacket[]

    for (const packet of parsedPackets) {
        const timestamp = packet.timestamp

        packets.dpr.push({
            timestamp,
            dpr: packet.dpr,
        })
        packets.tankPressures.push({
            timestamp,
            fuel: packet.fuel,
            lox: packet.lox,
        })

        // TODO add other types
    }

    // * TRANSLATE

    return packets
}
